import { useTranslation } from "react-i18next";

function NotFoundPage(){
  const {t} = useTranslation();

  return(
    <div className="container-fluid notFound">
      <div className="row">
        <div className="col px-4 px-lg-5 py-4 mt-3 mb-5 my-md-4 my-xl-5 text-center d-flex flex-row align-items-center justify-content-center gap-3 logOutBox">
          <p className="m-0">{t("404")}</p>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;